export default __webpack_public_path__ + "static/media/reports-22.08957ec2.png";